import './index_web.css';
import { View, Text, LanguageBtn } from '../../../component';
import YNAnswerView from '../../component/yn_answer_view';
import { useSelector } from 'react-redux';
import DefaultContainer from '../../../container/default_container';
import useTheme from '../../../utilities/hooks/theme';

const PreviewAnswerListWeb = ({ score, teamA, teamB, finalAnswerList }: any) => {
  let { language = 'en' } = useSelector((state: any) => state.app);
  const { FantasyTheme: theme } = useTheme();
  const totalPointsContainerStyle = {
    background: theme.contestTotalPointsBg,
    boxShadow: theme.contestTotalPointsBoxShadow,
    border: `1px solid ${theme.contestTotalPointsBorder}`
  };
  return (
    <DefaultContainer>
      <View className="previewAnswerListWrapper">
        <View className="previewAnswerList__headerWrapper">
          <View className={'previewAnswerList__header'}>
            <div className="previewAnswerList_header_title">Results</div>
            <div className="previewAnswerList_sub_header">
              <LanguageBtn />
              <div
                className="previewAnswerList_points"
                style={totalPointsContainerStyle}>{`${score} Points`}</div>
              <div className="previewAnswerList_teams">
                <Text className="previewAnswerList_header-team-name">{teamA.shortName}</Text>
                <Text className="previewAnswerList_header-team-name">VS</Text>
                <Text className="previewAnswerList_header-team-name">{teamB.shortName}</Text>
              </div>
            </div>
          </View>
        </View>
        <View style={{ paddingLeft: '7%', paddingBottom: '100px' }}>
          {finalAnswerList.map((item: any) => {
            const { sequence = 0 } = item;
            return (
              <YNAnswerView
                key={item.id}
                item={item}
                qNo={sequence}
                editMode={false}
                onChange2x={() => {}}
                onChangeMyAnswer={() => {}}
                language={language}
              />
            );
          })}
        </View>
      </View>
    </DefaultContainer>
  );
};
export default PreviewAnswerListWeb;
